<template>
  <el-dialog :title="dialogName" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
    <div class="main-box main-content specialChar-main">
      <el-form ref="dataForm" id="dataForm" :model="temp" :rules="rules" label-width="100px" label-suffix="：">
        <el-row :gutter="15">
          <el-col :span="20">
            <el-form-item  label="字符内容" prop="id">
              <el-input v-model="temp.wordInfo" style="font-size: 20px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
           <el-button @click="copyValue" type="primary">复制</el-button>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs type="border-card"   style="width: 100%;height: 400px;" class="single-tabs">
        <el-tab-pane label="上标">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in sup_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="下标">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in sub_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="序号">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in serialNumber_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="单位">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in unit_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="罗马符号">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in romanSymbols_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="数字符号">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in mathematicalSymbols_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="特殊符号">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in specialSymbols_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="汉字">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in chineseCharacters_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="希腊字母">
          <el-row :gutter="24">
            <el-col :span="2" v-for="(word, index) in greekAlphabet_list" :key="index" class="wordCol">
              <el-button @click="getValue(word)"  class="button-square wordValue"  >
                {{ word }}
              </el-button>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>

<script>

    export default {
        name: "partyBSelect",
        data() {
          return {
            dialogName: '字符内容',
            dialogVisible: false,                                       //弹框
            temp:{
            	wordInfo :'',       //字符内容
            },
            rules: {
            },

            sup_list: [],                           //上标集合
            sub_list: [],                           //下标集合
            serialNumber_list: [],                  //序号列表
            unit_list: [],                          //单位列表
            romanSymbols_list: [],                  //罗马符号
            mathematicalSymbols_list: [],           //数字符号
            specialSymbols_list: [],                //特殊符号
            chineseCharacters_list: [],             //汉字列表
            greekAlphabet_list: [],                 //希腊字母
          }
        },
        components: {

        },

        methods: {
          init(id){
            this.dialogVisible = true;
            this.temp.wordInfo = '';
            this.$nextTick(()=>{
              this.initWordInfo();
            })
          },

          initWordInfo(){
            return this.request({
              method:'post',
              url:'/web/service?method=tCoreSpecialCharacter_homeList',
              params: this.temp
            }).then((response) =>{
              if (response.code === 0) {
                let data = response.data
                if(data.sup_list != null){
                  this.sup_list = data.sup_list // 获取上标
                }
                if(data.sub_list != null){
                  this.sub_list = data.sub_list //获取下标
                }
                if(data.serialNumber_list != null){
                  this.serialNumber_list = data.serialNumber_list // 序号列表
                }
                if(data.unit_list != null){
                  this.unit_list = data.unit_list // 单位列表
                }
                if(data.romanSymbols_list != null){
                  this.romanSymbols_list = data.romanSymbols_list // 罗马符号
                }
                if(data.mathematicalSymbols_list != null){
                  this.mathematicalSymbols_list = data.mathematicalSymbols_list // 数字符号
                }
                if(data.specialSymbols_list != null){
                  this.specialSymbols_list = data.specialSymbols_list // 特殊符号
                }
                if(data.chineseCharacters_list != null){
                  this.chineseCharacters_list = data.chineseCharacters_list // 汉字列表
                }
                if(data.greekAlphabet_list != null){
                  this.greekAlphabet_list = data.greekAlphabet_list // 希腊字母
                }
              } else {
                this.$message.error(response.msg)
              }
            })

          },
          //获取内容
         getValue(word){
            if (word != null){
              this.temp.wordInfo += word;
            }
         },
         //复制内容
          copyValue(){
            const input = document.createElement('input');
            input.value = this.temp.wordInfo;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$message({message: '复制成功', type: 'success', duration: 1500, onClose: () => {
                this.dialogVisible = false;
            }})
          },
        }
    }
</script>

<style scoped>
.wordCol{
  margin-top: 10px;
}
.wordValue{
  font-size: 20px ;
  height: 30px !important;
  padding: 5px 10px !important;
  width: 35px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/WordInfo.vue